<template lang="jade">
  a.Button(class="Button--primary"
          ":skin"="skins.buttons"
          ":title"="fdata.title"
          style="height: auto"
          target="_blank"
          ":href"="fdata.url"
          ":text"="fdata.title")
    span.Button__text {{ fdata.title }}
</template>
<script>
import { skins } from 'src/vuex/getters'

export default {
  data () {
    return {}
  },
  props: {
    fdata: {
      type: Object,
      required: true
    }
  },
  vuex: {
    getters: {
      skins
    }
  }
}
</script>




// WEBPACK FOOTER //
// link.vue?56e09cae